import { COPY_PA3 } from "../lib/pruebaGratis";
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import InteractiveDemo from "../components/landing/InteractiveDemo";
import BeforeAfter from "../components/landing/BeforeAfter";
import PhoneInput, { phoneDigitsValid } from "../components/PhoneInput";
import SuritLogo from "../components/brand/SuritLogo";
import { INCLUYE } from "../lib/incluye";
import { cargarPlanes, formatoPrecio, modoDeCatalogo, precioDelPlan, rasgosDelPlan, textoIva, tieneSofi, useDatosAlta } from "../lib/planes";
// ROICalculator retirada del render — ver comentario al inicio de ese archivo (K0, ago 2026)
// import ROICalculator from "../components/landing/ROICalculator";
import Differentiators from "../components/landing/Differentiators";
import {
  MessageCircle,
  Calendar,
  BellRing,
  Users,
  Sparkles,
  Wallet,
  UserCog,
  ArrowRight,
  Check,
  Clock,
  PhoneCall,
  TrendingDown,
  ShieldCheck,
  Bot,
  Send,
  X,
} from "lucide-react";

const WHATSAPP_CONTRATAR_URL = "https://wa.me/529995118476?text=Hola%2C%20quiero%20contratar%20Surit%20Cl%C3%ADnicas%20para%20mi%20cl%C3%ADnica";

function WhatsAppIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
      <path d="M12 0C5.373 0 0 5.373 0 12c0 2.123.554 4.122 1.528 5.858L0 24l6.335-1.508A11.955 11.955 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.891 0-3.667-.498-5.2-1.37l-.373-.22-3.863.92.976-3.768-.242-.387A9.937 9.937 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
    </svg>
  );
}

const features = [
  { icon: MessageCircle, title: "Recepción IA por WhatsApp", desc: "Detecta señales de posible urgencia y deriva la conversación a tu equipo, sin emitir diagnósticos." },
  { icon: Calendar, title: "Agenda inteligente", desc: "Calendarios por doctor y servicio, con horarios disponibles en tiempo real." },
  // TEN.4: decia "24h antes, mensajes el mismo dia y reagendamiento sin intervencion humana".
  // Sofi no reagenda y no hay mensajes el mismo dia (auditoria #1 y #3). Lo que SI hace el Job
  // de recordatorios de agency: UNO, el dia anterior, con boton para confirmar.
  { icon: BellRing, title: "Recordatorio de cita", desc: "Un recordatorio por WhatsApp el día anterior a la cita, con un botón para confirmarla, en citas agendadas con al menos dos días de anticipación (planes con Sofi)." },
  { icon: Users, title: "CRM de pacientes", desc: "Historial de cada paciente: citas, notas internas y siguiente acción sugerida." },
  // TEN.4: se retiraron "Recuperacion de pacientes" (campanas que no existen, DT.234) y
  // "Reportes de conversion" (la metrica de citas creadas por IA esta retirada, DT.233). Lo que
  // las sustituye existe y se entrega hoy: el modulo financiero y el de colaboradores.
  { icon: Wallet, title: "Cobros, gastos y reportes", desc: "Registra el cobro de cada cita, los gastos de la clínica o de cada médico y descarga tus reportes en CSV." },
  { icon: UserCog, title: "Tu equipo, con permisos", desc: "Da acceso a recepción, médicos o contador y decide qué puede ver y hacer cada quien." },
];

// TEN.4 (DT.136): aqui vivia `pricing`, tres planes escritos a mano (Starter/Pro/Growth a
// $2,999/$5,999/$9,999) que ya no se venden: el boton de pago devolvia 502. Los planes salen
// ahora del catalogo de agency -- ver `lib/planes.js`.

// WEB.CL2 (11 Oct 2026): esta sección describe lo que el producto hace, sin prometer
// resultados ni disponibilidad (reglas de copy de Surit). Ver la prueba copyPublico.test.js.
const roi = [
  { icon: PhoneCall, title: "Mensajes atendidos", desc: "Sofi contesta los mensajes de WhatsApp también fuera de tu horario, sin que alguien tenga que estar pendiente del teléfono." },
  { icon: TrendingDown, title: "Recordatorio con confirmación", desc: "Un recordatorio por WhatsApp el día anterior, con un botón para confirmar la cita, en citas agendadas con al menos dos días de anticipación." },
  { icon: Check, title: "Citas en tu agenda", desc: "Sofi agenda en los horarios libres de cada profesional y la cita queda registrada en tu panel." },
];

// ── API base URL ──
const BASE_URL = "https://api-clinica-prod.delightfulglacier-4488b9be.westus.azurecontainerapps.io/api";

// ── Sofi chatbot widget ──

function SofiChatWidget() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    { role: "assistant", text: "Hola, soy Sofi 👋 La asistente IA de Surit Clínicas. ¿En qué puedo ayudarte?" }
  ]);
  const [input, setInput] = useState("");
  const [typing, setTyping] = useState(false);
  const [msgCount, setMsgCount] = useState(0);
  const MSG_LIMIT = 20;
  const bottomRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, typing]);

  useEffect(() => {
    if (open) inputRef.current?.focus();
  }, [open]);

  const sendMessage = async (text) => {
    const msg = text || input.trim();
    if (!msg || typing) return;
    if (msgCount >= MSG_LIMIT) return;
    if (!text) setInput("");
    setMsgCount(c => c + 1);
    setMessages(prev => [...prev, { role: "user", text: msg }]);
    setTyping(true);
    try {
      const res = await fetch(`${BASE_URL}/demo/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: msg }),
      });
      const data = await res.json();
      setMessages(prev => [...prev, { role: "assistant", text: data.reply || "Lo siento, ocurrió un error." }]);
    } catch {
      setMessages(prev => [...prev, { role: "assistant", text: "Ocurrió un error. Intenta de nuevo." }]);
    } finally {
      setTyping(false);
    }
  };

  const resetConversation = () => {
    setMessages([{ role: "assistant", text: "Hola, soy Sofi 👋 La asistente IA de Surit Clínicas. ¿En qué puedo ayudarte?" }]);
    setMsgCount(0);
    setInput("");
  };

  return (
    <>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, scale: 0.92, y: 12 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.92, y: 12 }}
            transition={{ duration: 0.18 }}
            className="fixed z-50 flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl"
            style={{ bottom: "5.5rem", right: "5.5rem", width: 340, height: 480 }}
          >
            {/* Header */}
            <div className="flex items-center justify-between px-4 py-3" style={{ backgroundColor: "#2563EB" }}>
              <div className="flex items-center gap-2.5">
                <div className="w-7 h-7 rounded-full bg-white/20 grid place-items-center">
                  <MessageCircle size={15} className="text-white" />
                </div>
                <div>
                  <div className="text-sm font-bold text-white leading-none">Sofi</div>
                  <div className="text-[10px] text-blue-200 mt-0.5">Surit Clínicas · IA Comercial</div>
                </div>
              </div>
              <button
                onClick={() => setOpen(false)}
                className="text-white/70 hover:text-white p-1 rounded-full hover:bg-white/10"
              >
                <X size={18} />
              </button>
            </div>

            {/* Messages */}
            <div className="flex-1 overflow-y-auto px-4 py-3 bg-slate-50 space-y-3">
              {messages.map((msg, i) => (
                <div key={i} className={`flex ${msg.role === "user" ? "justify-end" : "justify-start"}`}>
                  <div className={`max-w-[82%] rounded-xl px-3.5 py-2 text-sm leading-relaxed ${
                    msg.role === "user"
                      ? "bg-blue-600 text-white rounded-br-sm"
                      : "bg-white border border-slate-200 text-slate-800 rounded-bl-sm"
                  }`}>
                    {msg.text}
                  </div>
                </div>
              ))}
              {typing && (
                <div className="flex justify-start">
                  <div className="bg-white border border-slate-200 rounded-xl rounded-bl-sm px-4 py-3">
                    <div className="flex gap-1">
                      {[0, 1, 2].map(i => (
                        <span
                          key={i}
                          className="w-2 h-2 rounded-full bg-slate-400 animate-bounce"
                          style={{ animationDelay: `${i * 0.15}s` }}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              )}
              <div ref={bottomRef} />
            </div>

            {/* Input */}
            {msgCount >= MSG_LIMIT ? (
              <div className="border-t border-slate-100 px-4 py-3 bg-white text-center">
                <p className="text-xs text-slate-500 mb-2">
                  Has alcanzado el límite de esta conversación. Inicia una nueva sesión para continuar.
                </p>
                <button
                  onClick={resetConversation}
                  className="text-sm font-medium text-blue-600 hover:text-blue-700 underline"
                >
                  Nueva conversación
                </button>
              </div>
            ) : (
              <div className="border-t border-slate-100 px-3 py-2.5 bg-white flex items-center gap-2">
                <input
                  ref={inputRef}
                  value={input}
                  onChange={e => setInput(e.target.value)}
                  onKeyDown={e => e.key === "Enter" && sendMessage()}
                  placeholder="Escribe tu pregunta…"
                  disabled={typing}
                  className="flex-1 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm outline-none focus:border-blue-500 focus:bg-white disabled:opacity-50"
                />
                <button
                  onClick={() => sendMessage()}
                  disabled={!input.trim() || typing}
                  className="w-9 h-9 rounded-lg bg-blue-600 text-white grid place-items-center hover:bg-blue-700 disabled:opacity-40"
                >
                  <Send size={15} />
                </button>
              </div>
            )}
          </motion.div>
        )}
      </AnimatePresence>

      {/* Floating button */}
      <div className="fixed z-50 flex flex-col items-center gap-1.5" style={{ bottom: "1.5rem", right: "5.5rem" }}>
        {!open && (
          <span
            className="rounded-full px-2.5 py-0.5 text-[10px] font-semibold text-white shadow-sm"
            style={{ backgroundColor: "#0F172A" }}
          >
            Sofi IA
          </span>
        )}
        <button
          onClick={() => setOpen(v => !v)}
          className="w-14 h-14 rounded-full shadow-lg flex items-center justify-center hover:scale-105 active:scale-95 transition-all"
          style={{ backgroundColor: "#2563EB" }}
          aria-label={open ? "Cerrar chat" : "Abrir chat con Sofi IA"}
        >
          {open ? <X size={24} className="text-white" /> : <MessageCircle size={26} className="text-white" />}
        </button>
      </div>
    </>
  );
}

function isTokenValid(token) {
  try {
    const b64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(b64));
    return typeof payload.exp === "number" && payload.exp > Date.now() / 1000;
  } catch {
    return false;
  }
}

export default function Landing() {
  const navigate = useNavigate();
  const [checkoutModal, setCheckoutModal] = React.useState(null);
  const FORM_VACIO = { name: "", email: "", email2: "", phone: "", clinic_name: "" };
  const [checkoutForm, setCheckoutForm] = React.useState(FORM_VACIO);
  const [checkoutLoading, setCheckoutLoading] = React.useState(false);
  const [checkoutError, setCheckoutError] = React.useState(null);
  const [planes, setPlanes] = React.useState({ estado: "cargando", lista: [] });

  const leerPlanes = React.useCallback(() => {
    setPlanes({ estado: "cargando", lista: [] });
    cargarPlanes()
      .then((lista) => setPlanes({ estado: "ok", lista }))
      .catch(() => setPlanes({ estado: "error", lista: [] }));
  }, []);
  React.useEffect(() => { leerPlanes(); }, [leerPlanes]);
  // PRECIOS.1 I2: las frases del IVA salen de lib/planes.js según `iva.modo` del catálogo (sin el
  // campo: como hoy).
  const modoIva = modoDeCatalogo(planes.lista);
  // TEN.4: contacto y tope de usuarios del panel -- viven en el backend de clinicas, no aqui.
  // Si no llegan, se omite lo que dependa de ellos; nunca se escribe un valor de respaldo.
  const alta = useDatosAlta();
  const datosAlta = alta.datos;
  // 🔴 Decisión de Jesús: si los datos del plan que viven en ESTE repo (tope de usuarios del
  //    panel) no llegan, NO se pintan tarjetas a las que les falta un límite. Se avisa.
  const preciosEstado = planes.estado === "error" || alta.estado === "error" ? "error"
    : planes.estado === "ok" && alta.estado === "ok" ? "ok" : "cargando";
  const reintentarPrecios = () => { if (planes.estado !== "ok") leerPlanes(); if (alta.estado !== "ok") alta.reintentar(); };

  React.useEffect(() => {
    const token = localStorage.getItem("surit_token");
    if (token && isTokenValid(token)) {
      navigate("/app", { replace: true });
    }
  }, []);

  const handleCheckoutDirect = async (e) => {
    e.preventDefault();
    setCheckoutError(null);
    if (!checkoutForm.name.trim() || !checkoutForm.email.trim() || !checkoutForm.clinic_name.trim()) return;
    // TEN.4: un correo mal escrito es un cliente que paga y nunca recibe su acceso. Se pide dos
    // veces y tienen que coincidir ANTES de cobrar.
    if (checkoutForm.email.trim().toLowerCase() !== checkoutForm.email2.trim().toLowerCase()) {
      setCheckoutError("Los dos correos no coinciden. Revísalos: ahí te llegará tu acceso.");
      return;
    }
    if (!phoneDigitsValid(checkoutForm.phone, false)) {
      setCheckoutError("El teléfono debe tener 10 dígitos, o déjalo vacío.");
      return;
    }
    setCheckoutLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/checkout-direct`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          plan_slug: checkoutModal.slug,
          clinic_name: checkoutForm.clinic_name,
          customer_name: checkoutForm.name,
          customer_email: checkoutForm.email.trim(),
          customer_phone: checkoutForm.phone,
          mode: 'managed',
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        // El texto lo pone el backend (`{detail, code}`, DT.268). Un 422 trae una LISTA en
        // `detail`: no se pinta como objeto, se dice qué revisar.
        setCheckoutError(typeof data.detail === "string"
          ? data.detail
          : "Revisa tus datos: algún campo no es válido (por ejemplo, el correo).");
        return;
      }
      // TEN.4 (1.4): la pagina de exito lee de aqui a QUE correo se enviara el acceso. No va en
      // la URL (quedaria en logs e historial) ni en un endpoint (diria que correos compraron).
      try {
        sessionStorage.setItem("surit_alta", JSON.stringify({
          email: checkoutForm.email.trim(), plan: checkoutModal.name, sofi: tieneSofi(checkoutModal),
        }));
      } catch (_) { /* sin sessionStorage la pagina de exito lo dice sin el correo */ }
      window.location.href = data.checkout_url;
    } catch (err) {
      setCheckoutError("No se pudo conectar con el servicio de pagos. Intenta de nuevo.");
    } finally {
      setCheckoutLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white text-slate-900">

      {/* ── Navbar — fondo #0F172A igual a surit.ai ── */}
      <header className="sticky top-0 z-30 border-b border-white/10" style={{ background: "#0F172A" }} data-testid="landing-nav">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="landing-logo">
            <SuritLogo size={26} tone="oscuro" rotulo label="Surit.ai Clínicas" />
          </Link>
          <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-slate-400">
            <a href="#producto" className="hover:text-white transition-colors">Producto</a>
            <a href="#incluye" className="hover:text-white transition-colors">Qué incluye</a>
            <a href="#precios" className="hover:text-white transition-colors">Precios</a>
            <a href="#roi" className="hover:text-white transition-colors">En la práctica</a>
            <a href="#contacto" className="hover:text-white transition-colors">Contacto</a>
          </nav>
          <div className="flex items-center gap-2">
            {datosAlta?.prueba_clinicas_autoservicio === true && <Link to="/prueba-gratis" className="text-sm text-white px-3 py-2" data-testid="landing-prueba-gratis">{COPY_PA3.enviar}</Link>}
            <Link to="/login" className="hidden sm:inline-flex text-sm font-medium text-slate-400 hover:text-white px-3 py-2 transition-colors" data-testid="landing-login-link">
              Iniciar sesión
            </Link>
            <Link
              to="/demo"
              className="inline-flex items-center gap-1.5 text-white text-sm font-medium px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors shadow-sm"
              style={{ backgroundColor: "#2563EB" }}
              data-testid="landing-cta-demo-top"
            >
              Ver la demo <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </header>

      {/* ── Hero — fondo #0F172A con gradiente igual a surit.ai ── */}
      <section className="relative overflow-hidden" style={{ background: "#0F172A" }}>
        <div className="hero-blob" />
        <div className="hero-blob-2" />
        <div className="absolute inset-0 pointer-events-none" style={{ backgroundImage: "radial-gradient(rgba(255,255,255,0.04) 1px, transparent 1px)", backgroundSize: "24px 24px" }} />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8 pt-20 pb-24 lg:pt-28 lg:pb-32 grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7 animate-fade-up">
            {/* Badge — mismo estilo que surit.ai */}
            <div className="inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-sm font-medium text-blue-300 mb-5" style={{ backgroundColor: "rgba(37,99,235,0.15)", boxShadow: "0 0 0 1px rgba(37,99,235,0.3)" }}>
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
              </span>
              Diseñado para clínicas en México
            </div>

            <h1 className="font-display font-extrabold tracking-tighter text-[2.6rem] sm:text-5xl lg:text-[3.75rem] leading-[1.05] text-white">
              Tu clínica atendiendo <br className="hidden sm:block" />
              pacientes <span style={{ color: "#2563EB" }}>por WhatsApp</span>, también fuera de horario.
            </h1>

            <p className="mt-5 text-lg leading-relaxed max-w-2xl" style={{ color: "#94A3B8" }}>
              Surit Clínicas agenda citas, responde dudas y envía recordatorios desde una conversación natural en WhatsApp, y te da la agenda, los pacientes y los cobros de tu clínica en un solo panel.
            </p>

            <div className="mt-7 flex flex-wrap items-center gap-3">
              <a
                href="#precios"
                className="inline-flex items-center gap-2 text-white font-medium px-5 py-3 transition-colors shadow-sm"
                style={{ backgroundColor: "#2563EB", borderRadius: 10 }}
                data-testid="hero-cta-contratar"
              >
                Contratar <ArrowRight className="w-4 h-4" />
              </a>
              <a
                href={WHATSAPP_CONTRATAR_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 font-medium px-5 py-3 transition-colors"
                style={{ backgroundColor: "rgba(255,255,255,0.08)", color: "#E2E8F0", border: "1px solid rgba(255,255,255,0.15)", borderRadius: 10 }}
                data-testid="hero-cta-whatsapp"
              >
                <WhatsAppIcon className="h-5 w-5" /> Escríbenos por WhatsApp
              </a>
            </div>

            <div className="mt-8 flex items-center gap-6 text-sm" style={{ color: "#64748B" }}>
              <div className="flex items-center gap-2"><Bot className="w-4 h-4 text-blue-400" />Tono humano y profesional</div>
            </div>
          </div>

          {/* Hero visual */}
          <div className="lg:col-span-5 relative animate-fade-up" style={{ animationDelay: "120ms" }}>
            <HeroVisual />
          </div>
        </div>
      </section>

      {/* Trust strip */}
      <section className="border-y border-slate-200/70 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-8 grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
          {[
            "Atención por WhatsApp también fuera de tu horario",
            "Recordatorio con botón para confirmar",
            "Agenda, pacientes y cobros en un panel",
            "Datos aislados por clínica",
          ].map((v) => (
            <div key={v} className="text-sm font-medium text-slate-700">{v}</div>
          ))}
        </div>
      </section>

      {/* Features */}
      <section id="producto" className="py-24 sm:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-2xl">
            <div className="text-xs font-bold uppercase tracking-[0.18em] text-brand-electric">Producto</div>
            <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight mt-3">
              Todo lo que tu recepción necesita,<br /> en una sola plataforma.
            </h2>
            <p className="text-slate-600 mt-4">
              Diseñado para clínicas pequeñas y medianas: estéticas, dentales, nutrición, psicología y fisioterapia.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
            {features.map((f, i) => (
              <div
                key={f.title}
                className="group bg-white border border-slate-200 rounded-2xl p-6 card-hover animate-fade-up"
                style={{ animationDelay: `${i * 60}ms` }}
                data-testid={`feature-card-${i}`}
              >
                <div className="w-11 h-11 rounded-xl bg-blue-50 text-brand-electric grid place-items-center">
                  <f.icon className="w-5 h-5" />
                </div>
                <div className="font-display font-bold text-lg mt-4">{f.title}</div>
                <p className="text-slate-600 text-[0.95rem] mt-2 leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="incluye" aria-labelledby="incluye-titulo" className="py-24 sm:py-28 bg-slate-50 border-y border-slate-200/70">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h2 id="incluye-titulo" className="font-display text-3xl sm:text-4xl font-bold tracking-tight">
            Qué incluye Surit Clínicas
          </h2>
          <div className="mt-12 space-y-10">
            {[
              { clave: "conSofi", titulo: "Sofi en tu WhatsApp (planes con Sofi)" },
              { clave: "panel", titulo: "Tu panel (todos los planes)" },
              { clave: "proximamente" },
            ].filter(({ clave }) => INCLUYE[clave].length > 0).map(({ clave, titulo }) => {
              const proximo = clave === "proximamente";
              const Icono = proximo ? Clock : Check;
              return (
                <div key={clave} data-testid={`incluye-${clave}`}>
                  <div className="flex flex-wrap items-center gap-3">
                    {titulo && <h3 className="font-display text-xl font-bold">{titulo}</h3>}
                    <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold ${proximo ? "bg-slate-100 text-slate-600" : "bg-emerald-50 text-emerald-700"}`}>
                      <Icono className="h-4 w-4" aria-hidden="true" />
                      {proximo ? "Próximamente" : "Disponible hoy"}
                    </span>
                  </div>
                  <ul className="mt-5 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                    {INCLUYE[clave].map(({ titulo: funcion, detalle }) => (
                      <li key={funcion} className="bg-white border border-slate-200 rounded-xl p-6">
                        <h4 className="font-display font-bold text-lg">{funcion}</h4>
                        {detalle && <p className="text-slate-600 text-[0.95rem] mt-2 leading-relaxed">{detalle}</p>}
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Aclaración estratégica */}
      <section className="py-16 bg-slate-50 border-y border-slate-200/70">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">
            Surit complementa tu sistema clínico actual
          </h2>
          <p className="text-slate-600 mt-4 leading-relaxed">
            Surit Clínicas atiende WhatsApp, agenda y envía recordatorios de cita a tus pacientes. No
            sustituye tu expediente clínico electrónico: trabaja junto al sistema que ya usas, o junto
            a tu proceso actual si todavía no tienes uno.
          </p>
        </div>
      </section>

      {/* Seguridad de tus datos */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight inline-flex items-center gap-2">
            <ShieldCheck className="w-6 h-6 text-emerald-600" /> Seguridad de tus datos
          </h2>
          <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-5 text-left">
            {[
              "Infraestructura en Microsoft Azure",
              "Datos aislados por clínica",
              "Comunicación cifrada y acceso autenticado",
            ].map((item) => (
              <li key={item} className="flex items-start gap-3 bg-white border border-slate-200 rounded-xl p-4">
                <Check className="w-5 h-5 text-emerald-600 mt-0.5 shrink-0" />
                <span className="text-slate-700 text-sm">{item}</span>
              </li>
            ))}
          </ul>
          <a
            href="https://surit.ai/seguridad"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-6 text-sm font-medium text-brand-electric hover:underline"
          >
            Más sobre seguridad →
          </a>
        </div>
      </section>

      {/* ROI */}
      <section id="roi" className="py-24 sm:py-28 bg-slate-50 border-y border-slate-200/70">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-2xl">
            <div className="text-xs font-bold uppercase tracking-[0.18em] text-brand-electric">En la práctica</div>
            <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight mt-3">
              Lo que cambia en tu recepción.
            </h2>
            <p className="text-slate-600 mt-4">
              Esto es lo que Surit hace por tu recepción en los planes con Sofi.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-12">
            {roi.map((r, i) => (
              <div key={r.title} className="bg-white border border-slate-200 rounded-2xl p-6 animate-fade-up" style={{ animationDelay: `${i * 70}ms` }}>
                <div className="w-10 h-10 rounded-xl bg-blue-50 text-brand-electric grid place-items-center mb-3">
                  <r.icon className="w-5 h-5" />
                </div>
                <div className="font-display font-bold">{r.title}</div>
                <p className="text-slate-600 text-sm mt-2">{r.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Nuevas secciones Bloque C ── */}
      <InteractiveDemo />
      <BeforeAfter />
      {/* ROICalculator retirada (K0, ago 2026): proyectaba ingresos con una tasa de recuperación
          del 70% inventada, sin ningún cliente real de donde derivarla. Ver comentario en el
          archivo del componente para lo que haría falta para reactivarla. */}
      <Differentiators contactoEmail={datosAlta?.contacto_email} />

      {/* Pricing — plan destacado con dark card igual a surit.ai */}
      <section id="precios" className="py-24 sm:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-2xl">
            <div className="text-xs font-bold uppercase tracking-[0.18em] text-brand-electric">Precios</div>
            <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight mt-3">Planes pensados para clínicas mexicanas.</h2>
            {/* J1-B (17 Ago 2026): de esta linea se quito la coletilla que afirmaba que los planes
                incluyen plantillas con aprobacion de Meta. Es la misma afirmacion que DT.90 elimino de
                Templates.js en J1 -- ninguna plantilla de este repo se ha enviado nunca a Meta.
                Sobrevivio aqui porque J1
                la quito donde la encontro y no la busco en el resto del repo, que es peor: aqui la
                lee un prospecto en la landing publica ANTES de comprar. */}
            {/* TEN.4: decia "Todos los planes incluyen implementacion guiada y capacitacion" y cada
                tarjeta "+ implementacion" -- el setup es 0 en todos los planes. Lo que se dice
                ahora es lo que el cliente necesita saber ANTES de pagar.
                ⚠️ COPY PENDIENTE DE APROBACION (parada 3.5 de TEN.4). */}
            <p className="text-slate-600 mt-4">
              {textoIva("landingPrecios", modoIva)}
            </p>
            <p className="text-slate-600 mt-2 text-sm">
              En los planes con Sofi, la conexión del WhatsApp de tu clínica la hacemos contigo después del pago.
              {/* 🔴 NO se afirma quién paga los mensajes de Meta: depende de en qué WABA vive el
                  número (la del cliente sólo con Embedded Signup, hoy cerrado; la acompañada lo
                  agrega bajo la de Surit). Pendiente de la decisión de Jesús -- ninguna cifra por
                  mensaje hasta entonces. */}
            </p>
          </div>

          {preciosEstado === "cargando" && (
            <div className="mt-12 text-sm text-slate-500" data-testid="precios-cargando">Cargando planes…</div>
          )}
          {preciosEstado === "error" && (
            <div className="mt-12 rounded-xl border border-amber-200 bg-amber-50 p-5 text-sm text-amber-800" data-testid="precios-error">
              No pudimos cargar los datos de los planes en este momento.{" "}
              <button onClick={reintentarPrecios} className="underline font-medium">Reintentar</button>
              {datosAlta?.ventas_email && (
                <> o escríbenos a <a href={`mailto:${datosAlta.ventas_email}`} className="underline">{datosAlta.ventas_email}</a></>
              )}.
            </div>
          )}
          {/* TEN.4: con el checkout público cerrado (bandera del backend, hasta la clave live de
              Stripe) no se ofrece "Contratar": sería un botón que falla. */}
          {preciosEstado === "ok" && datosAlta?.checkout_abierto === false && (
            <div className="mt-8 rounded-xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-700" data-testid="checkout-cerrado">
              La contratación en línea todavía no está abierta.
              {datosAlta?.ventas_email && (
                <> Escríbenos a <a href={`mailto:${datosAlta.ventas_email}`} className="underline">{datosAlta.ventas_email}</a> para contratar.</>
              )}
            </div>
          )}
          {preciosEstado === "ok" && (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mt-12 items-stretch">
            {planes.lista.filter((p) => !p.requires_quote).map((p) => (
              <div
                key={p.slug}
                className="relative flex flex-col"
                style={{ borderRadius: 14, padding: "1.75rem", backgroundColor: "#FFFFFF", border: "1px solid #E2E8F0", boxShadow: "0 1px 2px rgba(15,23,42,.06)" }}
                data-testid={`pricing-card-${p.slug}`}
              >
                <div className="text-sm font-semibold uppercase tracking-widest text-slate-500">{p.name}</div>
                <div className="mt-3 flex items-baseline gap-2">
                  <span className="font-display text-4xl font-extrabold tracking-tighter text-slate-900">{formatoPrecio(p)}</span>
                  <span className="text-sm opacity-70">MXN /mes</span>
                </div>
                <div className="text-xs opacity-70 mt-1">{textoIva("tarjeta", precioDelPlan(p).modo)}</div>
                <ul className="mt-6 space-y-2.5 text-sm flex-1">
                  {rasgosDelPlan(p, datosAlta?.colaboradores_por_plan).map((f) => (
                    <li key={f} className="flex items-start gap-2">
                      <Check className="w-4 h-4 mt-0.5 shrink-0 text-brand-electric" style={{ color: "#2563EB" }} />
                      <span className="text-slate-700">{f}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-7 flex flex-col gap-2">
                  {datosAlta?.checkout_abierto === true && (
                  <button
                    onClick={() => { setCheckoutForm(FORM_VACIO); setCheckoutError(null); setCheckoutModal(p); }}
                    className="inline-flex items-center justify-center gap-1.5 font-medium px-5 py-3 transition-colors"
                    style={{ borderRadius: 10, backgroundColor: "#0F172A", color: "#FFFFFF" }}
                    data-testid={`pricing-cta-contratar-${p.slug}`}
                  >
                    Contratar <ArrowRight className="w-4 h-4" />
                  </button>
                  )}
                  {/* 🔴 Sin "prueba gratis": la prueba es la demo de un clic. */}
                  <Link
                    to="/demo"
                    className="inline-flex items-center justify-center gap-1.5 text-sm font-medium px-5 py-2.5 transition-colors"
                    style={{ borderRadius: 10, border: "1px solid #E2E8F0", color: "#64748B" }}
                    data-testid={`pricing-cta-demo-${p.slug}`}
                  >
                    Ver la demo
                  </Link>
                </div>
              </div>
            ))}
          </div>
          )}
          {preciosEstado === "ok" && planes.lista.filter((p) => p.requires_quote).map((p) => (
            <div key={p.slug} className="mt-6 rounded-2xl border border-slate-200 bg-slate-50 p-6 flex flex-col sm:flex-row sm:items-center gap-4 justify-between" data-testid={`pricing-card-${p.slug}`}>
              <div>
                <div className="text-sm font-semibold uppercase tracking-widest text-slate-500">{p.name}</div>
                <div className="text-slate-700 text-sm mt-1">¿Tienes una clínica grande? Agenda una llamada y armamos un paquete a tu medida.</div>
              </div>
              <a
                href="https://wa.me/529995118476?text=Hola,%20me%20interesa%20el%20plan%20Cl%C3%ADnica%20grande%20de%20Surit%20Cl%C3%ADnicas"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center gap-1.5 font-medium px-5 py-3"
                style={{ borderRadius: 10, backgroundColor: "#25D366", color: "#FFFFFF" }}
                data-testid={`pricing-cta-${p.slug}`}
              >
                Contactar ventas <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          ))}
        </div>
      </section>

      {/* CTA final */}
      <section id="contacto" className="py-24 sm:py-28 text-white relative overflow-hidden" style={{ background: "#0F172A" }}>
        <div className="absolute inset-0 pointer-events-none" style={{ backgroundImage: "radial-gradient(rgba(255,255,255,0.04) 1px, transparent 1px)", backgroundSize: "24px 24px" }} />
        <div className="relative max-w-5xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="font-display text-3xl sm:text-5xl font-extrabold tracking-tighter">
            Atiende y agenda por WhatsApp desde un solo panel.
          </h2>
          <p className="mt-5 max-w-2xl mx-auto" style={{ color: "#94A3B8" }}>
            Sin instalaciones: entras desde el navegador. En los planes con Sofi, la conexión del WhatsApp de tu clínica la hacemos contigo.
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <a
              href="#precios"
              className="inline-flex items-center gap-2 text-white font-medium px-5 py-3 transition-colors shadow-sm"
              style={{ backgroundColor: "#2563EB", borderRadius: 10 }}
              data-testid="cta-bottom-contratar"
            >
              Contratar <ArrowRight className="w-4 h-4" />
            </a>
            <a
              href={WHATSAPP_CONTRATAR_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 font-medium px-5 py-3 rounded-xl transition-colors"
              style={{ border: "1px solid rgba(255,255,255,0.2)", color: "#FFFFFF" }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.1)"}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = "transparent"}
              data-testid="cta-bottom-whatsapp"
            >
              <WhatsAppIcon className="h-5 w-5" /> Escríbenos por WhatsApp
            </a>
            <Link
              to="/demo"
              className="inline-flex items-center gap-2 font-medium px-5 py-3 rounded-xl transition-colors border border-white/20 text-white hover:bg-white/10"
              data-testid="cta-bottom-demo"
            >
              Ver la demo <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>

      {/* Disclaimer médico */}
      <div style={{ backgroundColor: "#F8FAFC", borderTop: "1px solid #E2E8F0" }}>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <p className="text-xs text-slate-400 leading-relaxed max-w-4xl mx-auto text-center">
            <strong className="text-slate-500">Aviso importante:</strong>{" "}
            El asistente IA de Surit Clínicas está diseñado para gestión administrativa: agendamiento,
            recordatorios, preguntas frecuentes y seguimiento de citas. No proporciona diagnósticos médicos,
            no sustituye la consulta con un profesional de salud y no está diseñado para atender urgencias médicas.
            En casos de emergencia, el asistente deriva al paciente a comunicarse directamente con la clínica
            o servicios de emergencia.
          </p>
        </div>
      </div>

      {/* ── Footer — idéntico a surit.ai: fondo #0F172A, logo + columnas ── */}
      <footer style={{ backgroundColor: "#0F172A" }}>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
          <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
            <div className="col-span-2 md:col-span-1">
              <Link to="/">
                <SuritLogo size={26} tone="oscuro" rotulo label="Surit.ai Clínicas" />
              </Link>
              <p className="mt-3 text-sm text-slate-400">
                IA para clínicas mexicanas.<br />Sin código, sin complicaciones.
              </p>
            </div>

            <div>
              <h3 className="mb-3 text-sm font-semibold text-white">Solución</h3>
              <ul className="space-y-2 text-sm text-slate-400">
                <li><a href="#producto" className="hover:text-white transition-colors">Producto</a></li>
                <li><a href="#incluye" className="hover:text-white transition-colors">Qué incluye</a></li>
                <li><a href="#roi" className="hover:text-white transition-colors">En la práctica</a></li>
                <li><a href="#precios" className="hover:text-white transition-colors">Contratar</a></li>
              </ul>
            </div>

            <div>
              <h3 className="mb-3 text-sm font-semibold text-white">Industrias</h3>
              <ul className="space-y-2 text-sm text-slate-400">
                {["Clínicas", "Restaurantes", "Despachos", "Escuelas", "Inmobiliarias"].map((i) => (
                  <li key={i}><a href="#contacto" className="hover:text-white transition-colors">{i}</a></li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="mb-3 text-sm font-semibold text-white">Contacto</h3>
              <ul className="space-y-2 text-sm text-slate-400">
                <li>
                  <a href="https://wa.me/529995118476" target="_blank" rel="noopener noreferrer" className="inline-flex hover:opacity-80 transition-opacity" style={{ color: "#25D366" }} aria-label="Contactar por WhatsApp">
                    <WhatsAppIcon className="h-5 w-5" />
                  </a>
                </li>
                <li>
                  {datosAlta?.ventas_email && (
                    <a href={`mailto:${datosAlta.ventas_email}`} className="hover:text-white transition-colors">{datosAlta.ventas_email}</a>
                  )}
                </li>
                <li>
                  <a href="https://surit.ai/privacidad" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Aviso de privacidad</a>
                </li>
                <li>
                  <a href="https://surit.ai/seguridad" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Seguridad</a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-8 pt-6 text-center text-xs text-slate-500" style={{ borderTop: "1px solid rgba(255,255,255,0.1)" }}>
            © {new Date().getFullYear()} Surit.ai — Tuxtla Gutiérrez, Chiapas, México
          </div>
        </div>
      </footer>

      {/* ── Botón flotante de WhatsApp — right-6 ── */}
      <div className="fixed bottom-6 right-6 z-50 flex flex-col items-center gap-1.5">
        <span className="rounded-full px-2.5 py-0.5 text-[10px] font-semibold text-white shadow-sm whitespace-nowrap" style={{ backgroundColor: "#128C7E" }}>
          Ventas
        </span>
        <a
          href="https://wa.me/529995118476"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-14 h-14 rounded-full shadow-lg"
          style={{ backgroundColor: "#25D366" }}
          aria-label="Contactar por WhatsApp"
        >
          <WhatsAppIcon className="h-7 w-7 text-white" />
        </a>
      </div>

      {/* ── Sofi IA chat widget — right-[5.5rem] ── */}
      <SofiChatWidget />

      {/* Modal checkout directo */}
      {checkoutModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 px-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h3 className="text-lg font-bold text-slate-900">Contratar plan {checkoutModal.name}</h3>
                <p className="text-sm text-slate-500 mt-1">{textoIva("modal", precioDelPlan(checkoutModal).modo, precioDelPlan(checkoutModal).importe)}</p>
              </div>
              <button onClick={() => setCheckoutModal(null)} className="text-slate-400 hover:text-slate-600 p-1">
                <X size={20} />
              </button>
            </div>
            <form onSubmit={handleCheckoutDirect} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Nombre completo *</label>
                <input
                  required
                  value={checkoutForm.name}
                  onChange={e => setCheckoutForm(f => ({ ...f, name: e.target.value }))}
                  placeholder="Dra. María García"
                  className="w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Correo electrónico *</label>
                <input
                  required
                  type="email"
                  value={checkoutForm.email}
                  onChange={e => setCheckoutForm(f => ({ ...f, email: e.target.value }))}
                  placeholder="maria@clinica.com"
                  className="w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-blue-500"
                />
                <p className="text-xs text-slate-500 mt-1">Aquí te llegará el enlace para crear tu contraseña.</p>
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Confirma tu correo *</label>
                <input
                  required
                  type="email"
                  value={checkoutForm.email2}
                  onChange={e => setCheckoutForm(f => ({ ...f, email2: e.target.value }))}
                  onPaste={e => e.preventDefault()}
                  placeholder="Escríbelo otra vez"
                  className="w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-blue-500"
                  data-testid="checkout-email2"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Teléfono</label>
                <PhoneInput
                  value={checkoutForm.phone}
                  onChange={(digits) => setCheckoutForm(f => ({ ...f, phone: digits }))}
                  placeholder="55 1234 5678"
                  className="w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Nombre de tu clínica *</label>
                <input
                  required
                  value={checkoutForm.clinic_name}
                  onChange={e => setCheckoutForm(f => ({ ...f, clinic_name: e.target.value }))}
                  placeholder="Clínica Dental García"
                  className="w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-blue-500"
                />
              </div>
              {/* TEN.4: en los planes con Sofi, lo que NO pasa solo se dice ANTES de pagar. */}
              {tieneSofi(checkoutModal) && (
                <div className="text-xs rounded-lg bg-slate-50 border border-slate-200 p-3 text-slate-600" data-testid="checkout-aviso-whatsapp">
                  La conexión del WhatsApp de tu clínica la hacemos contigo después del pago.
                </div>
              )}
              {checkoutError && (
                <div className="text-sm rounded-lg bg-rose-50 text-rose-700 px-3 py-2" data-testid="checkout-error">{checkoutError}</div>
              )}
              <button
                type="submit"
                disabled={checkoutLoading}
                className="w-full bg-blue-600 text-white font-medium py-3 rounded-lg hover:bg-blue-700 disabled:opacity-50 transition-colors"
              >
                {checkoutLoading ? "Procesando…" : textoIva("botonPagar", precioDelPlan(checkoutModal).modo, precioDelPlan(checkoutModal).importe)}
              </button>
            </form>
          </div>
        </div>
      )}

    </div>
  );
}

// ── Animated HeroVisual ──
const CONVERSATION = [
  { role: "patient", text: "Hola, ¿cuánto cuesta una valoración?" },
  // TEN.4: la cita del ejemplo esta a mas de dos dias. El recordatorio solo sale en citas
  // agendadas con al menos dos dias de anticipacion (K1.6): con "mañana" la frase de abajo mentia.
  { role: "ai",      text: "¡Hola! Una valoración inicial cuesta $500 MXN y dura 30 min. Tengo lugar el jueves a las 10:30 o el viernes a las 16:00 ¿te agendo?" },
  { role: "patient", text: "El jueves 10:30 perfecto 🙌" },
  { role: "ai",      text: "Listo, te aparté el horario ✅ Te enviaré un recordatorio el día anterior." },
];

function HeroVisual() {
  const [visibleCount, setVisibleCount] = useState(0);
  const [showTyping, setShowTyping] = useState(false);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let cancelled = false;

    async function runSequence() {
      await delay(500);
      setVisibleCount(0);
      setShowTyping(false);

      for (let i = 0; i < CONVERSATION.length; i++) {
        if (cancelled) return;
        const msg = CONVERSATION[i];

        if (msg.role === "ai") {
          setShowTyping(true);
          await delay(1200);
          if (cancelled) return;
          setShowTyping(false);
        }

        setVisibleCount(i + 1);

        const pause = i < CONVERSATION.length - 1 ? 1500 : 3500;
        await delay(pause);
        if (cancelled) return;
      }

      // Reset and loop
      if (!cancelled) {
        setVisibleCount(0);
        setShowTyping(false);
        await delay(800);
        if (!cancelled) setTick(v => v + 1);
      }
    }

    runSequence();
    return () => { cancelled = true; };
  }, [tick]); // eslint-disable-line react-hooks/exhaustive-deps

  const visibleMessages = CONVERSATION.slice(0, visibleCount);

  return (
    <div className="relative w-full">
      {/* Phone-like WhatsApp panel */}
      <div className="relative bg-white border border-slate-200 rounded-3xl shadow-elevated p-4 sm:p-5 max-w-md mx-auto" style={{ minHeight: 280 }}>
        <div className="flex items-center gap-3 pb-3 border-b border-slate-100">
          <div className="w-10 h-10 rounded-full bg-emerald-100 grid place-items-center text-emerald-700 font-semibold">TC</div>
          <div>
            <div className="font-semibold text-slate-900 text-sm">Tu clínica</div>
            <div className="text-[11px] text-emerald-600 flex items-center gap-1">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" /> Sofi IA en línea
            </div>
          </div>
          <div className="ml-auto text-[10px] uppercase tracking-widest text-slate-400">WhatsApp</div>
        </div>

        <div className="space-y-2 py-4 flex flex-col" style={{ minHeight: 160 }}>
          <AnimatePresence initial={false}>
            {visibleMessages.map((msg, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className={msg.role === "patient" ? "bubble bubble-patient" : "bubble bubble-ai"}
              >
                {msg.text}
              </motion.div>
            ))}
          </AnimatePresence>

          {showTyping && (
            <motion.div
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              className="bubble bubble-ai flex items-center gap-1"
            >
              {[0, 1, 2].map(i => (
                <span
                  key={i}
                  className="w-1.5 h-1.5 rounded-full bg-slate-400 animate-bounce"
                  style={{ animationDelay: `${i * 0.15}s` }}
                />
              ))}
            </motion.div>
          )}
        </div>

        <div className="flex items-center gap-2 pt-2 border-t border-slate-100">
          <div className="flex-1 h-9 rounded-full bg-slate-100 px-3 text-xs text-slate-400 flex items-center">Escribe un mensaje…</div>
          <div className="w-9 h-9 rounded-full bg-emerald-500 grid place-items-center text-white"><ArrowRight className="w-4 h-4" /></div>
        </div>
      </div>

      {/* TEN.4: aqui habia una tarjeta flotante con una cifra de citas confirmadas del dia.
          Cifra de resultado sin cliente real detras (auditoria #27, misma familia que J1-B):
          se retira, no se sustituye por otra. */}

      {/* Floating AI card */}
      <div className="hidden sm:flex absolute -right-4 -top-4 text-white rounded-2xl shadow-elevated p-4 items-center gap-3 max-w-[230px]" style={{ backgroundColor: "#0F172A" }}>
        <div className="w-9 h-9 rounded-xl grid place-items-center" style={{ backgroundColor: "rgba(37,99,235,0.3)" }}><Sparkles className="w-4 h-4" /></div>
        <div className="text-xs leading-snug">
          <span className="font-semibold">Sofi:</span> ofrece los horarios libres de tu agenda
        </div>
      </div>
    </div>
  );
}

function delay(ms) {
  return new Promise(res => setTimeout(res, ms));
}
